'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, FreeMode } from 'swiper/modules';
import { TestimonialCard } from './TestimonialCard'; // Import Part 1

// Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';

const GOLD_GRADIENT = 'linear-gradient(135deg, #faaf40 0%, #f9d976 50%, #faaf40 100%)';

const testimonials = [
  { id: 1, quote: "Aura is the opposite of traditional gyms. The 20-minute sessions actually fit my life.", name: 'Alizheh Khan', title: 'Kinetic Core Member', imageUrl: '/about/member1.webp' },
  { id: 2, quote: "The honest comparison isn't a gym fee—it's high-end personal training.", name: 'Arsalan Nadeem', title: 'Metabolic Sculpt Member', imageUrl: '/about/member2.webp' },
  { id: 3, quote: "Every session is supervised one-on-one. You don't just get equipment; you get accountability.", name: 'Sana Jawad', title: 'Signature Sanctuary Member', imageUrl: '/about/member1.webp' },
  { id: 4, quote: "Hospital-grade hygiene and elite training. Aura reclaimed my time.", name: 'Hamza Malik', title: 'Elite Member', imageUrl: '/about/member2.webp' }
];

export default function TestimonialsSection() {
  return (
    <section className="h-screen min-h-[600px] flex flex-col justify-center bg-black text-white overflow-hidden py-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-8 gap-4">
          <div className="max-w-2xl">
            <motion.span initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} className="text-[9px] uppercase tracking-[0.5em] mb-2 block font-bold text-[#faaf40]">
              Elite Testimonials
            </motion.span>
            <motion.h2 initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} className="text-3xl sm:text-5xl font-light tracking-tighter italic leading-none">
              VOICES OF <span className="font-extrabold not-italic aura-text-gradient">AURA WELLNESS</span>
            </motion.h2>
          </div>
          <p className="hidden md:block text-zinc-500 max-w-[150px] text-right uppercase tracking-widest text-[8px] font-bold leading-relaxed opacity-60">
            Redefining Personal <br/> Performance Standards
          </p>
        </div>

        {/* Slider Container */}
        <div className="testimonial-swiper-container">
          <Swiper
            modules={[Autoplay, Pagination, FreeMode]}
            spaceBetween={20}
            slidesPerView={1.1}
            freeMode={true}
            loop={true}
            autoplay={{ delay: 4500, disableOnInteraction: false }}
            pagination={{ clickable: true, dynamicBullets: true }}
            breakpoints={{
              768: { slidesPerView: 2.1 },
              1280: { slidesPerView: 2.5 },
            }}
            className="!pb-12 !overflow-visible"
          >
            {testimonials.map((item) => (
              <SwiperSlide key={item.id}>
                <TestimonialCard item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style jsx global>{`
        .aura-text-gradient {
          background: ${GOLD_GRADIENT};
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
        .swiper-pagination-bullet { background: #333 !important; opacity: 1; }
        .swiper-pagination-bullet-active { background: #faaf40 !important; width: 25px; height: 5px; border-radius: 3px; }
      `}</style>
    </section>
  );
}